// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_kpi_main {
  max-width: 100%;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: #F2F3FC;

}

.kpi_container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 20px 0;

}

.kpi_box {
  background-color: white;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  padding: 15px 20px;
  gap: 5px;
  border-radius: 10px;
  border: solid 1px #2B64F5;
}

.kpi_box p {
  margin: 0;
}

.kpi_box_datas{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.home_kpi_toggle {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.home_kpi_lists {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
  background-color: #F2F3FC;
}

.home_kpi_lists_transition {
  max-height: 100%;
}

/*********************************************** TOGGLE CSS *************************************************/
.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #ccc;
  border-radius: 16px;
  width: 58px;
  height: 32px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
  content: "";
}

.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: left 0.25s;
}

.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}

.toggle-checkbox:checked+.toggle-switch {
  background: #2B64F5;
}

.toggle-checkbox:checked+.toggle-switch:before {
  left: 30px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}


@media screen and (min-width: 1600px) {}`, "",{"version":3,"sources":["webpack://./src/components/DataComponents/KPI/KPI.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;;AAEjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6GAA6G;AAC7G;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0DAA0D;EAC1D,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,0DAA0D;EAC1D,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;;AAGA,uCAAuC","sourcesContent":[".home_kpi_main {\n  max-width: 100%;\n  padding: 10px 20px;\n  border-radius: 10px;\n  background-color: #F2F3FC;\n\n}\n\n.kpi_container {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  padding: 20px 0;\n\n}\n\n.kpi_box {\n  background-color: white;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: end;\n  padding: 15px 20px;\n  gap: 5px;\n  border-radius: 10px;\n  border: solid 1px #2B64F5;\n}\n\n.kpi_box p {\n  margin: 0;\n}\n\n.kpi_box_datas{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.home_kpi_toggle {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.home_kpi_lists {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.4s ease-in-out;\n  background-color: #F2F3FC;\n}\n\n.home_kpi_lists_transition {\n  max-height: 100%;\n}\n\n/*********************************************** TOGGLE CSS *************************************************/\n.toggle {\n  cursor: pointer;\n  display: inline-block;\n}\n\n.toggle-switch {\n  display: inline-block;\n  background: #ccc;\n  border-radius: 16px;\n  width: 58px;\n  height: 32px;\n  position: relative;\n  vertical-align: middle;\n  transition: background 0.25s;\n}\n\n.toggle-switch:before,\n.toggle-switch:after {\n  content: \"\";\n}\n\n.toggle-switch:before {\n  display: block;\n  background: linear-gradient(to bottom, #fff 0%, #eee 100%);\n  border-radius: 50%;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  transition: left 0.25s;\n}\n\n.toggle:hover .toggle-switch:before {\n  background: linear-gradient(to bottom, #fff 0%, #fff 100%);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);\n}\n\n.toggle-checkbox:checked+.toggle-switch {\n  background: #2B64F5;\n}\n\n.toggle-checkbox:checked+.toggle-switch:before {\n  left: 30px;\n}\n\n.toggle-checkbox {\n  position: absolute;\n  visibility: hidden;\n}\n\n.toggle-label {\n  margin-left: 5px;\n  position: relative;\n  top: 2px;\n}\n\n\n@media screen and (min-width: 1600px) {}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
